import { useState, useRef, useEffect } from "react";
import "./PageContextMenu.css";

export default function PageContextMenu({
    page,
    onMakeMainPage,
    onRename,
    onDelete,
    onClose,
    position
}) {
    const [isRenaming, setIsRenaming] = useState(false);
    const [newName, setNewName] = useState(page?.name || "");
    const [isDeleting, setIsDeleting] = useState(false);
    const menuRef = useRef(null);
    const inputRef = useRef(null);

    // Fermer le menu si on clique en dehors
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    // Focus sur l'input quand on passe en mode renommage
    useEffect(() => {
        if (isRenaming && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isRenaming]);

    const handleRenameClick = () => {
        setIsRenaming(true);
    };

    const handleRenameSubmit = async (e) => {
        e?.preventDefault();
        if (!newName.trim() || newName === page.name) {
            setIsRenaming(false);
            return;
        }

        await onRename(page.id, newName.trim());
        onClose();
    };

    const handleRenameKeyDown = (e) => {
        if (e.key === "Escape") {
            setNewName(page.name);
            setIsRenaming(false);
        }
    };

    const handleDeleteClick = () => {
        setIsDeleting(true);
    };

    const handleDeleteConfirm = async () => {
        await onDelete(page.id);
        onClose();
    };

    const handleDeleteCancel = () => {
        setIsDeleting(false);
    };

    const handleMakeMainPage = async () => {
        await onMakeMainPage(page.id);
        onClose();
    };

    return (
        <div 
            ref={menuRef}
            className="page-context-menu"
            style={{
                top: position?.y || 0,
                left: position?.x || 0
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {isDeleting ? (
                <div className="pcm-confirm">
                    <span className="pcm-confirm-icon">⚠️</span>
                    <span className="pcm-confirm-text">Supprimer "{page.name}" ?</span>
                    <div className="pcm-confirm-actions">
                        <button 
                            className="pcm-confirm-btn pcm-confirm-cancel"
                            onClick={handleDeleteCancel}
                        >
                            Annuler
                        </button>
                        <button 
                            className="pcm-confirm-btn pcm-confirm-delete"
                            onClick={handleDeleteConfirm}
                        >
                            Supprimer
                        </button>
                    </div>
                </div>
            ) : isRenaming ? (
                <form className="pcm-rename-form" onSubmit={handleRenameSubmit}>
                    <input
                        ref={inputRef}
                        type="text"
                        className="pcm-rename-input"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                        onKeyDown={handleRenameKeyDown}
                        placeholder="Nom de la page"
                    />
                    <div className="pcm-rename-actions">
                        <button 
                            type="button" 
                            className="pcm-rename-btn pcm-rename-cancel"
                            onClick={() => {
                                setNewName(page.name);
                                setIsRenaming(false);
                            }}
                        >
                            ✕
                        </button>
                        <button 
                            type="submit" 
                            className="pcm-rename-btn pcm-rename-confirm"
                            disabled={!newName.trim()}
                        >
                            ✓
                        </button>
                    </div>
                </form>
            ) : (
                <>
                    <div className="pcm-header">
                        <span className="pcm-page-name">{page.name}</span>
                    </div>
                    <button className="pcm-item" onClick={handleMakeMainPage}>
                        <span className="pcm-item-icon">🏠</span>
                        <span className="pcm-item-text">Principale</span>
                    </button>
                    <button className="pcm-item" onClick={handleRenameClick}>
                        <span className="pcm-item-icon">✏️</span>
                        <span className="pcm-item-text">Renommer</span>
                    </button>
                    <button className="pcm-item pcm-item-duplicate">
                        <span className="pcm-item-icon">📋</span>
                        <span className="pcm-item-text">Dupliquer</span>
                    </button>
                    <div className="pcm-divider"></div>
                    <button className="pcm-item pcm-item-danger" onClick={handleDeleteClick}>
                        <span className="pcm-item-icon">🗑️</span>
                        <span className="pcm-item-text">Supprimer</span>
                    </button>
                </>
            )}
        </div>
    );
}

